import { useNavigate } from 'react-router-dom';
import { useCommandModel } from 'utils/hooks/useCommandModel';
import { useNotifications } from 'utils/hooks/useNotifications';
import { queryClient } from 'utils/react-query/queryClient';
import { useApi } from 'utils/request/useApi';
import { type Snmp, createInitialSnmpState } from './SnmpModel';
import { loadSnmp } from './command/loadSnmp';
import { saveSnmp } from './command/saveSnmp';

export const useSnmp = () => {
  const navigate = useNavigate();
  const model = useCommandModel(
    createInitialSnmpState(),
    {
      api: useApi(),
      showNotification: useNotifications().showNotification,
      navigate,
      queryClient,
    },
    {},
  );

  return {
    actions: {
      loadSnmp: () => {
        model.dispatch(loadSnmp);
      },
      saveSnmp: (values: Snmp) => {
        model.dispatch(saveSnmp, {
          values,
        });
      },
    },
    model,
  };
};
